module.exports = __webpack_public_path__ + "static/media/TJ.bc17f365.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/TJ.svg
// module id = 2274
// module chunks = 7